// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1Ii5m","log":"ModalInventoryLogs_log__3SWOn","date":"ModalInventoryLogs_date__36c8D","userName":"ModalInventoryLogs_userName__23nUw"};